import Parameter from '../../Parameter';
import { convertAttachmentLinkHtmlString } from '../../../components/Editor/utils/tinyUtils';

export default class RichText extends Parameter {
  /**
   * Replacing a11y conform links in RichText payload to normal anchors with data attributes
   * to not store design/look and feel relevant information, that might change over time, in the database.
   * This keeps the database clean and allows us to change the appearance of a11y conform links to our needs,
   * when ever needed. Even for already existing customer content.
   */
  public getPayloadValue(): { name: string; value: string } {
    const { name, value } = super.getPayloadValue();

    // no value -> empty rich text, must be savable nonetheless
    if (!value) {
      return { name, value: '' };
    }

    return { name, value: convertAttachmentLinkHtmlString(value) };
  }
}
